/**
 * authedUser.js
 * Written by: Alex Kasemir
 */
import { createSelector } from 'reselect';

/**
 * Description of the selectedQuestion selector
 *
 * @param {Object} state - The redux store to pull data from
 */

const selectedQuestion = createSelector(
  [
    (state) => state.question.selected,
    (state) => state.question.byId,
  ],
  (selected, byId) => byId[selected],
);

export default selectedQuestion;
